import mdPage from '../../src/views/approval/approval'
import forwarding from '../../src/views/approval/type/forwarding'
import handle from '../../src/views/approval/type/handle'
import submission from '../../src/views/approval/type/submission'

export default {
  mdPage: mdPage,
  forwarding:forwarding,
  handle: handle,
  submission: submission,
}